import mitt from 'mitt';
import { BusEvents } from '@/helpers/enums';

// Create a new emitter
const eventBus = mitt<Record<BusEvents, unknown>>();

// Export that emitter
export default eventBus;
